import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
} from "@mui/material";
import type { ValidCharacterItem } from "../types/api-types";

interface RemoveCharacterConfirmationDialogProps {
  open: boolean;
  character: ValidCharacterItem | null;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const RemoveCharacterConfirmationDialog = ({
  open,
  character,
  isDeleting,
  onConfirm,
  onCancel,
}: RemoveCharacterConfirmationDialogProps) => {
  return (
    <Dialog open={open} onClose={isDeleting ? undefined : onCancel}>
      <DialogTitle>Remove Character</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to remove the character &quot;
          {character?.description}&quot;? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
        >
          {isDeleting ? "Removing..." : "Remove"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveCharacterConfirmationDialog;
